import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-876f8f3c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "find-work-orders-container" }
const _hoisted_2 = { class: "grid-container" }

import ModalBase from "@/components/ui/modals/modal-base.vue";
import FindInput from "@/components/find/find-input.vue";
import GridFilterSummary from "@/components/ui/grid/grid-filter-summary.vue";
import { DxToolbarItem } from "devextreme-vue/popup";
import { computed, inject, ref, watch, nextTick } from "vue";
import FindWorkOrderResults from "@/components/find/work-orders/find-work-order-results.vue";
import { WorkOrderFindResult } from "@/types/find/work-orders/WorkOrderFindResult";
import { GridFilter } from "@/types/ui/GridFilter";
import { FindWorkOrderFilters } from "@/types/find/work-orders/FindWorkOrderFilters";
import FilterWorkOrderFindResults from "@/components/find/work-orders/filter-work-order-find-results.vue";
import { WorkOrderFindQuery } from "@/types/find/work-orders/WorkOrderFindQuery";
import displayErrorMessage from "@/utils/ErrorHandling";
import { AcquaintApiNextClient } from "@/services/AcquaintApiNextClient";
import { getErrorMessage } from "bright-logic-core/src/errors";


export default /*#__PURE__*/_defineComponent({
  __name: 'find-work-order-modal',
  props: {
  /**
   * The boolean value used with `v-model` to control the visibility or state of a modal or component.
   * @type {boolean}
   * @required
   */
  modelValue: {
    type: Boolean,
    required: true,
  },
},
  emits: [
  /**
   * Triggered when the `modelValue` changes. This is used to update the v-model variable in the parent component.
   * @property {boolean} value - Indicates whether the modal has been opened or closed.
   */
  "update:modelValue",
  /**
   * Triggered when a contact is selected from the list.
   * @param {Object} selectedWorkOrder - The selected work order object.
   * @param {Array} workOrderIds - List of all work order Ids.
   * @param {Number} currentIndex - The currentIndex of the selected work order.
   */
  "workOrderSelected",
],
  setup(__props, { emit }) {

const props = __props;




const showModal = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit("update:modelValue", value),
});

const acquaintNextApiClient = inject(
  "AcquaintApiNextClient",
) as AcquaintApiNextClient;
const currentIndex = ref<number>(0);
const searching = ref(false);
const searchQuery = ref("");
const workOrders = ref<WorkOrderFindResult[]>([]);
const selectedWorkOrder = ref<WorkOrderFindResult>();
const showFiltersModal = ref(false);
const filters = ref<FindWorkOrderFilters>({
  status: { id: -1, description: "" },
  branch: { id: -1, description: "" },
});

const summaryFilters = computed(() => {
  const gridFilters: GridFilter[] = [];

  // No filters so return blank array so summary shows All
  if (!filters.value) {
    return [];
  }

  if (filters.value.status.id > -1) {
    gridFilters.push({
      title: "Status",
      values: [filters.value.status],
      dataSource: [],
    });
  }
  if (filters.value.branch.id > -1) {
    gridFilters.push({
      title: "Branch",
      values: [filters.value.branch],
      dataSource: [],
    });
  }

  return gridFilters;
});

const fetchWorkOrders = async () => {
  searching.value = true;
  const query: WorkOrderFindQuery = {
    textToFind: searchQuery.value,
    status: filters.value.status.id,
    branch: filters.value.branch.id,
  };

  try {
    workOrders.value = await acquaintNextApiClient.httpPost<
      WorkOrderFindResult[]
    >("workOrders/find", query);
  } catch (ex) {
    displayErrorMessage(getErrorMessage(ex));
    workOrders.value = [];
  }
  searching.value = false;
};

const onInputChanged = async (query: string) => {
  searchQuery.value = query;
  // To avoid unnecessary api calls, only perform search if user has entered more than 2 characters
  if (!searchQuery.value || searchQuery.value.length < 2) {
    selectedWorkOrder.value = undefined;
    workOrders.value = [];
    return;
  }

  // Get results back from api
  await fetchWorkOrders();
};

const filtersApplied = async (selectedFilters: FindWorkOrderFilters) => {
  filters.value = JSON.parse(JSON.stringify(selectedFilters));

  if (searchQuery.value) {
    await fetchWorkOrders();
  }
};

const onSelectClick = async () => {
  if (!selectedWorkOrder.value) {
    return;
  }

  emitSelectedWorkOrder();
};

const onRowSelected = async (e: WorkOrderFindResult, rowIndex: number) => {
  if (e) {
    selectedWorkOrder.value = e;
  }

  currentIndex.value = rowIndex;
};
const onRowClick = async (e: WorkOrderFindResult) => {
  if (!e) {
    return;
  }
  selectedWorkOrder.value = e;
  emitSelectedWorkOrder();
};

// Code that will focus the search bar - it has a timeout to allow the animation to complete
const searchInputRef = ref();
watch(searchInputRef, async (value) => {
  if (value) {
    await nextTick();
    setTimeout(() => {
      value.focus();
    }, 400);
  }
});

const emitSelectedWorkOrder = () => {
  showModal.value = false;
  emit(
    "workOrderSelected",
    selectedWorkOrder.value,
    workOrders.value.map((item) => item.id),
    currentIndex.value,
  );
  workOrders.value = [];
};

const closeModal = () => {
  emit("workOrderSelected", undefined);
  showModal.value = false;
  workOrders.value = [];
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ModalBase, {
      title: "Find Work Order",
      modelValue: showModal.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showModal).value = $event)),
      height: "80vh",
      "show-close-button": true,
      onModalClosed: _cache[2] || (_cache[2] = ($event: any) => (emit('workOrderSelected', undefined)))
    }, {
      "non-scrollable-content": _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          (showModal.value)
            ? (_openBlock(), _createBlock(FindInput, {
                key: 0,
                ref_key: "searchInputRef",
                ref: searchInputRef,
                onChanged: onInputChanged
              }, null, 512))
            : _createCommentVNode("", true),
          _createVNode(GridFilterSummary, {
            rowCount: workOrders.value.length,
            filters: summaryFilters.value,
            onFilterClick: _cache[0] || (_cache[0] = ($event: any) => (showFiltersModal.value = true)),
            dropdownMenuDisable: false,
            showMenu: false
          }, null, 8, ["rowCount", "filters"]),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(FindWorkOrderResults, {
              data: workOrders.value,
              searching: searching.value,
              onRowClick: onRowClick,
              onRowSelected: onRowSelected
            }, null, 8, ["data", "searching"])
          ])
        ])
      ]),
      footer: _withCtx(() => [
        _createVNode(_unref(DxToolbarItem), {
          widget: "dxButton",
          toolbar: "bottom",
          location: "after",
          options: {
          text: 'Select',
          disabled: !selectedWorkOrder.value,
          onClick: () => onSelectClick(),
        }
        }, null, 8, ["options"]),
        _createVNode(_unref(DxToolbarItem), {
          widget: "dxButton",
          toolbar: "bottom",
          location: "after",
          options: { text: 'Close', onClick: () => closeModal() }
        }, null, 8, ["options"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(FilterWorkOrderFindResults, {
      modelValue: showFiltersModal.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((showFiltersModal).value = $event)),
      filters: filters.value,
      onFiltersApplied: filtersApplied
    }, null, 8, ["modelValue", "filters"])
  ], 64))
}
}

})